import http from "infra/http";

import { useQuery } from "react-query";
import { PaginateResult } from "core/resources/types/shared";
import { RelatorioReservasResponse, FiltroRelatorioReservas } from '../typings/index';

function useRelatorioReservas(
  params: FiltroRelatorioReservas
  , enabled = false
) {
  return useQuery(
    [`/v1/relatorios/reservas/paginado`, params],
    async () => {
      const { data } = await http.get<PaginateResult<RelatorioReservasResponse>>(
        "/v1/relatorios/reservas/paginado",
        {
          params: params,
        }
      );


      return data;
    }
    , {
      enabled
    }
  );
}

export default useRelatorioReservas;
